import { Link } from 'react-router-dom';
import Header from '../Components/Header';
import Footer from '../Components/Footer';
import Seo from '../Components/Seo';
import { SITE_NAME } from '../data/seo';
import '../assests/css/coming-soon.css';

function ComingSoon({ title, parent, path }) {
  return (
    <div className="coming-soon-page">
      <Seo
        path={path}
        title={`${title} | School ERP Software – ${SITE_NAME}`}
        description={`${title} is coming soon on ${SITE_NAME} school ERP and school management software. Register for a demo to see admissions, fees, academics, and parent apps.`}
        noIndex
      />
      <Header />
      <main className="coming-soon">
        <div className="container">
          <div className="coming-soon-card">
            {parent ? <p className="coming-soon-kicker">{parent}</p> : null}
            <h1>{title}</h1>
            <p className="coming-soon-badge">Coming Soon</p>
            <p className="coming-soon-copy">
              This page is being prepared. Meanwhile, explore {SITE_NAME} school ERP or register for a demo
              to see how connected school systems can help your team.
            </p>
            <div className="coming-soon-actions">
              <Link to="/" className="coming-soon-home">
                Back to Home
              </Link>
              {title !== 'Register for Demo' ? (
                <Link to="/register-for-demo" className="eduya-cta">
                  Register for Demo
                </Link>
              ) : null}
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}

export default ComingSoon;
